function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPurinaWithName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 290.84 186.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 38.95,
    width: 61.29,
    height: 61.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.19,94.62v1h.53c.54,0,.8-.12.8-.5s-.26-.53-.81-.53Zm1.84.49a.77.77,0,0,1-.7.79L67,97.26h-.56L65.82,96h-.63v1.29H64.7v-3h1.08c.84,0,1.25.26,1.25.82m.32-.9a2.26,2.26,0,0,0-1.63-.68,2.21,2.21,0,0,0-1.59.66,2.28,2.28,0,0,0-.69,1.63,2.24,2.24,0,0,0,.68,1.6,2.19,2.19,0,0,0,1.6.67,2.28,2.28,0,0,0,1.63-.67A2.21,2.21,0,0,0,68,95.83a2.26,2.26,0,0,0-.66-1.62m.22-.22a2.54,2.54,0,0,1,.74,1.83,2.45,2.45,0,0,1-.75,1.82,2.68,2.68,0,0,1-1.84.77,2.6,2.6,0,0,1-1.83-.77,2.57,2.57,0,0,1-.76-1.82A2.63,2.63,0,0,1,63.91,94a2.51,2.51,0,0,1,1.81-.74,2.56,2.56,0,0,1,1.85.76",
    style: {
      fill: "#1c1c1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68,98.44H59.49V40.63H1.68Zm2-55.74H57.31V96.38H3.63Z",
    style: {
      fill: "#c72122"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.81,
    y: 44.76,
    width: 16.52,
    height: 16.52,
    style: {
      fill: "#c72122"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.84,
    y: 44.76,
    width: 16.52,
    height: 16.52,
    style: {
      fill: "#c72122"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.33,
    y: 61.28,
    width: 16.51,
    height: 16.51,
    style: {
      fill: "#c72122"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.81,
    y: 77.8,
    width: 16.52,
    height: 16.52,
    style: {
      fill: "#c72122"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.84,
    y: 77.8,
    width: 16.52,
    height: 16.52,
    style: {
      fill: "#c72122"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05.1h13.64l35.49,69.24L177.67.1h13.64V99.41H173.13V46.61l-26.75,52.8H138l-26.75-52.8v52.8H93.05Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,99h.05l-13-17H231.27A6.18,6.18,0,0,1,225,75.9V23.06A6.18,6.18,0,0,1,231.27,17h32.31a6.18,6.18,0,0,1,6.23,6.06V75.9A6.18,6.18,0,0,1,263.58,82h-7.7l13.66,17A19.33,19.33,0,0,0,288,79.6V19.35A19.36,19.36,0,0,0,268.63,0H226.22a19.46,19.46,0,0,0-19.35,19.35V79.6A19.46,19.46,0,0,0,226.22,99h12.62l32.54,45.71h19.46Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.12 107.68 236.09 107.68 247.43 123.18 93.12 123.18 93.12 107.68",
    style: {
      fill: "#b1a499"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.15,154.23v-9.71a4,4,0,0,0-.76-2.68A3,3,0,0,0,109,141a3.85,3.85,0,0,0-3.12,1.21,5.8,5.8,0,0,0-1,3.74v8.33h-2.26v-9.71a4.1,4.1,0,0,0-.76-2.68,3,3,0,0,0-2.39-.89,3.7,3.7,0,0,0-3.11,1.28,6.87,6.87,0,0,0-1,4.17v7.83H93.12V139.3H95l.37,2h.11a4.37,4.37,0,0,1,1.8-1.71,5.64,5.64,0,0,1,2.61-.61q3.5,0,4.58,2.54h.11a4.74,4.74,0,0,1,1.93-1.86,6.07,6.07,0,0,1,2.89-.68,5.07,5.07,0,0,1,3.79,1.3,5.83,5.83,0,0,1,1.26,4.16v9.74Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.88,135.26a1.52,1.52,0,0,1,.38-1.14,1.35,1.35,0,0,1,1-.36,1.33,1.33,0,0,1,.94.37,1.47,1.47,0,0,1,.39,1.13,1.51,1.51,0,0,1-.39,1.14,1.33,1.33,0,0,1-.94.37,1.31,1.31,0,0,1-1-.37A1.55,1.55,0,0,1,118.88,135.26Zm2.45,19h-2.26V139.3h2.26Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,154.51a6.36,6.36,0,0,1-5-2,8.18,8.18,0,0,1-1.78-5.65,8.46,8.46,0,0,1,1.8-5.78,6.5,6.5,0,0,1,5.15-2.05,10.55,10.55,0,0,1,2.15.23,7.43,7.43,0,0,1,1.69.55l-.7,1.92a10.39,10.39,0,0,0-1.63-.5,7.41,7.41,0,0,0-1.57-.2q-4.55,0-4.55,5.81a6.91,6.91,0,0,0,1.11,4.22,3.87,3.87,0,0,0,3.29,1.47,10.16,10.16,0,0,0,3.83-.8v2A8.13,8.13,0,0,1,132.1,154.51Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.22,139a9.6,9.6,0,0,1,1.79.16l-.32,2.1a8,8,0,0,0-1.63-.2,4,4,0,0,0-3.1,1.47,5.35,5.35,0,0,0-1.29,3.66v8h-2.26V139.3h1.87l.26,2.77h.11a6.58,6.58,0,0,1,2-2.25A4.48,4.48,0,0,1,146.22,139Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.69,146.76a8.28,8.28,0,0,1-1.84,5.7,6.5,6.5,0,0,1-5.08,2,6.81,6.81,0,0,1-3.56-.94,6.32,6.32,0,0,1-2.4-2.7,9.42,9.42,0,0,1-.84-4.11,8.26,8.26,0,0,1,1.82-5.69,6.46,6.46,0,0,1,5.07-2,6.32,6.32,0,0,1,5,2.09A8.21,8.21,0,0,1,163.69,146.76Zm-11.38,0a7.06,7.06,0,0,0,1.15,4.36,4.54,4.54,0,0,0,6.73,0,7,7,0,0,0,1.15-4.36,6.94,6.94,0,0,0-1.15-4.33,4.05,4.05,0,0,0-3.4-1.48,4,4,0,0,0-3.35,1.46A7,7,0,0,0,152.31,146.76Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6,139.06a5.56,5.56,0,0,1,4.57,2,10.75,10.75,0,0,1,0,11.4,5.54,5.54,0,0,1-4.56,2,6.42,6.42,0,0,1-2.66-.54,5,5,0,0,1-2-1.66h-.16l-.48,1.92h-1.62V133h2.26v5.15c0,1.15,0,2.19-.11,3.1h.11A5.38,5.38,0,0,1,174.6,139.06Zm-.33,1.89a4,4,0,0,0-3.34,1.33,10.26,10.26,0,0,0,0,9,4,4,0,0,0,3.37,1.35,3.46,3.46,0,0,0,3.1-1.52,7.78,7.78,0,0,0,1-4.36,7.53,7.53,0,0,0-1-4.35A3.62,3.62,0,0,0,174.27,141Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.56,135.26a1.52,1.52,0,0,1,.38-1.14,1.32,1.32,0,0,1,.95-.36,1.3,1.3,0,0,1,.94.37,1.44,1.44,0,0,1,.4,1.13,1.48,1.48,0,0,1-.4,1.14,1.39,1.39,0,0,1-1.89,0A1.55,1.55,0,0,1,184.56,135.26Zm2.45,19h-2.26V139.3H187Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,146.76a8.23,8.23,0,0,1-1.84,5.7,6.49,6.49,0,0,1-5.08,2,6.77,6.77,0,0,1-3.55-.94,6.2,6.2,0,0,1-2.4-2.7,9.42,9.42,0,0,1-.85-4.11,8.21,8.21,0,0,1,1.83-5.69,6.46,6.46,0,0,1,5.07-2,6.32,6.32,0,0,1,5,2.09A8.2,8.2,0,0,1,204.69,146.76Zm-11.37,0a7.13,7.13,0,0,0,1.14,4.36,4.56,4.56,0,0,0,6.74,0,7,7,0,0,0,1.15-4.36,6.94,6.94,0,0,0-1.15-4.33,4.06,4.06,0,0,0-3.4-1.48,4,4,0,0,0-3.35,1.46A7,7,0,0,0,193.32,146.76Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.69,154.23v-9.71a4.1,4.1,0,0,0-.76-2.68,3,3,0,0,0-2.37-.89,3.85,3.85,0,0,0-3.12,1.21,5.74,5.74,0,0,0-1,3.74v8.33h-2.26v-9.71a4,4,0,0,0-.77-2.68A3,3,0,0,0,215,141a3.67,3.67,0,0,0-3.11,1.28,6.87,6.87,0,0,0-1,4.17v7.83h-2.26V139.3h1.84l.36,2H211a4.46,4.46,0,0,1,1.81-1.71,5.58,5.58,0,0,1,2.61-.61c2.33,0,3.86.85,4.57,2.54h.11a4.77,4.77,0,0,1,1.94-1.86,6,6,0,0,1,2.89-.68,5.09,5.09,0,0,1,3.79,1.3,5.83,5.83,0,0,1,1.26,4.16v9.74Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.92,154.51a6.85,6.85,0,0,1-5.23-2,7.82,7.82,0,0,1-1.91-5.6,8.62,8.62,0,0,1,1.78-5.73,5.88,5.88,0,0,1,4.77-2.13,5.63,5.63,0,0,1,4.44,1.85,7.07,7.07,0,0,1,1.64,4.87v1.43H236.12a6,6,0,0,0,1.33,4,4.58,4.58,0,0,0,3.55,1.36,11.92,11.92,0,0,0,4.77-1v2a11.72,11.72,0,0,1-2.27.74A12.79,12.79,0,0,1,240.92,154.51Zm-.62-13.58a3.69,3.69,0,0,0-2.86,1.17,5.31,5.31,0,0,0-1.26,3.24H244a5,5,0,0,0-.95-3.28A3.36,3.36,0,0,0,240.3,140.93Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.42,179.71a5.45,5.45,0,0,1-4.51-2A8.88,8.88,0,0,1,92.29,172a9,9,0,0,1,1.63-5.72,5.5,5.5,0,0,1,4.55-2.06,5.43,5.43,0,0,1,4.72,2.32h.12l.33-2.05h1.78v21.64h-2.26v-6.39a15.28,15.28,0,0,1,.15-2.32h-.18A5.32,5.32,0,0,1,98.42,179.71Zm.34-1.9a4.11,4.11,0,0,0,3.3-1.21,6.61,6.61,0,0,0,1.1-4.09V172a7.46,7.46,0,0,0-1.06-4.51,4,4,0,0,0-3.37-1.37,3.45,3.45,0,0,0-3,1.54A7.65,7.65,0,0,0,94.63,172a7.48,7.48,0,0,0,1,4.3A3.55,3.55,0,0,0,98.76,177.81Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.34,164.5v9.69a3.88,3.88,0,0,0,.83,2.72,3.39,3.39,0,0,0,2.6.9,4.22,4.22,0,0,0,3.43-1.28,6.45,6.45,0,0,0,1.08-4.18V164.5h2.27v14.93h-1.87l-.33-2h-.12a4.48,4.48,0,0,1-1.93,1.69,6.48,6.48,0,0,1-2.81.59,5.66,5.66,0,0,1-4.08-1.3,5.47,5.47,0,0,1-1.36-4.14V164.5Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.23,172a8.28,8.28,0,0,1-1.84,5.7,6.5,6.5,0,0,1-5.08,2.05,6.81,6.81,0,0,1-3.56-.94,6.32,6.32,0,0,1-2.4-2.7,9.42,9.42,0,0,1-.84-4.11,8.21,8.21,0,0,1,1.83-5.69,6.43,6.43,0,0,1,5.06-2,6.32,6.32,0,0,1,5,2.09A8.21,8.21,0,0,1,140.23,172Zm-11.38,0a7.06,7.06,0,0,0,1.15,4.36,4.54,4.54,0,0,0,6.73,0,7,7,0,0,0,1.15-4.36,6.94,6.94,0,0,0-1.15-4.33,4.05,4.05,0,0,0-3.4-1.48,4,4,0,0,0-3.35,1.46A7,7,0,0,0,128.85,172Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,177.84a7.15,7.15,0,0,0,1.15-.09,8.53,8.53,0,0,0,.89-.18v1.73a4.29,4.29,0,0,1-1.08.29,7.93,7.93,0,0,1-1.29.12q-4.33,0-4.33-4.57v-8.88h-2.14v-1.09l2.14-.94.95-3.19h1.31v3.46H151v1.76h-4.33v8.79a3,3,0,0,0,.64,2.07A2.23,2.23,0,0,0,149,177.84Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,160.46a1.48,1.48,0,0,1,.38-1.14,1.32,1.32,0,0,1,1-.36,1.3,1.3,0,0,1,.94.37,1.44,1.44,0,0,1,.4,1.13,1.48,1.48,0,0,1-.4,1.14,1.39,1.39,0,0,1-1.89,0A1.51,1.51,0,0,1,155,160.46Zm2.45,19h-2.26V164.5h2.26Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.52,179.71a6.83,6.83,0,0,1-5.22-2,7.78,7.78,0,0,1-1.92-5.6,8.67,8.67,0,0,1,1.78-5.73,5.91,5.91,0,0,1,4.78-2.13,5.63,5.63,0,0,1,4.44,1.85A7.06,7.06,0,0,1,174,171v1.43H163.73a5.85,5.85,0,0,0,1.33,4,4.57,4.57,0,0,0,3.54,1.36,11.89,11.89,0,0,0,4.77-1v2a11.5,11.5,0,0,1-2.27.74A12.65,12.65,0,0,1,168.52,179.71Zm-.61-13.58A3.69,3.69,0,0,0,165,167.3a5.43,5.43,0,0,0-1.26,3.24h7.81a5,5,0,0,0-1-3.28A3.33,3.33,0,0,0,167.91,166.13Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.09,179.43v-9.65a3.88,3.88,0,0,0-.84-2.73,3.37,3.37,0,0,0-2.6-.9,4.28,4.28,0,0,0-3.43,1.27,6.37,6.37,0,0,0-1.09,4.18v7.83h-2.26V164.5h1.84l.36,2.05h.11a4.64,4.64,0,0,1,1.95-1.71,6.27,6.27,0,0,1,2.79-.61,5.69,5.69,0,0,1,4.06,1.3,5.54,5.54,0,0,1,1.37,4.16v9.74Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.82,177.84a7.24,7.24,0,0,0,1.15-.09c.37-.06.67-.12.89-.18v1.73a4.27,4.27,0,0,1-1.09.29,7.72,7.72,0,0,1-1.28.12q-4.34,0-4.33-4.57v-8.88H193v-1.09l2.14-.94,1-3.19h1.31v3.46h4.33v1.76h-4.33v8.79a3,3,0,0,0,.64,2.07A2.22,2.22,0,0,0,199.82,177.84Z",
    style: {
      fill: "#79787a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.72,
    y: 35.19,
    width: 18.65,
    height: 4,
    rx: 1.73,
    transform: "translate(73.67 -138.96) rotate(38.1)",
    style: {
      fill: "#e6e1dc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.63,
    y: 49.73,
    width: 24.52,
    height: 5.26,
    rx: 2.28,
    transform: "translate(7.97 134.46) rotate(-30)",
    style: {
      fill: "#e6e1dc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.09,
    cy: 34.85,
    r: 4.77,
    style: {
      fill: "#e6e1dc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.52,
    cy: 25.72,
    r: 3.47,
    style: {
      fill: "#e6e1dc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.56,
    cy: 64.38,
    r: 3.47,
    style: {
      fill: "#e6e1dc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.14,
    cy: 58.66,
    r: 4.9,
    style: {
      fill: "#e6e1dc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.3,
    cy: 71.32,
    r: 3.47,
    style: {
      fill: "#e6e1dc"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPurinaWithName);
export default __webpack_public_path__ + "static/media/logo_purina_with-name.70078b30.svg";
export { ForwardRef as ReactComponent };